import axios from "axios";
import router from "./router"
import element from "element-ui";
import store from "./store"
import myConst from "./util/my-const";
import fun from "./util/util";

// axios.defaults.baseURL = "https://5619c6826k.oicp.vip/iems/web"   //人防项目

axios.defaults.baseURL = "https://www.energies-cloud.com:8020/iems/web"  // 华为云生产环境

// axios.defaults.baseURL = "http://192.168.110.6:8020/iems/web"

// axios.defaults.baseURL = "http://192.168.110.12:8020/iems/web"  //公司测试服务器

// axios.defaults.baseURL = "http://192.168.0.245:8020/iems/web"  //山西项目现场

// axios.defaults.baseURL = "http://192.168.0.128:8020/iems/web"  //张家口项目单台区

// axios.defaults.baseURL = "http://localhost:8020/iems/web"
// axios.defaults.baseURL = "http://192.168.110.8:8020/iems/web" 

// axios.defaults.baseURL = "http://192.168.3.10:8020/iems/web"  

// axios.defaults.baseURL = "http://192.168.110.25:8020/iems/web"   //晓东IP

// axios.defaults.baseURL = "http://192.168.110.30:8020/iems/web"   //攀登IP

// axios.defaults.baseURL = "http://192.168.110.129:8020/iems/web"   //虚拟机IP

// axios.defaults.baseURL = "http://192.168.110.68:8020/iems/web" //攀登桌子底下的主机ip

// axios.defaults.baseURL = "http://192.168.99.225:8020/iems/web"   //扬州黑马高科

// axios.defaults.baseURL = "http://192.168.0.245:8020/iems/web"  //山西项目现场

// axios.defaults.baseURL = "http://192.168.0.11:8020/iems/web"  //张家口项目单台区

// axios.defaults.baseURL = "http://10.164.18.165:8020/iems/web"

// axios.defaults.baseURL = "http://10.219.208.206:8020/iems/web"  //新疆巴音布鲁克

// axios.defaults.baseURL = "http://124.70.58.47:8020/iems/web"  //



const request = axios.create({
    // timeout: 10000,
    headers: {
        'Content-Type': "application/json; charset=utf-8;"
    }
});
//每次请求时头部带着token
request.interceptors.request.use(config => {
    // console.log("请求添加token：" + store.getters.getToken);
    if (!fun.isNull(store.getters.getToken)) {
        config.headers[myConst.headToken] = store.getters.getToken;
        // config.cancelToken = new axios.CancelToken(function (cancel) {
        //     store.commit('CanCelRequest/pushToken', {cancelToken: cancel})
        //   })

    }
    return config;
},error=>{
    return Promise.reject(error)
});
let isStop401 = false
request.interceptors.response.use(
    response => {
        //获取返回数据
        let res = response.data;
        // 如果返回的是文件流
        if (response.data instanceof Blob) {
            return response;
        }
        // 如果返回的是登录成功或者是已登录状态
        if(res.code == myConst.code.success || res.code == myConst.code.logged){
            return response;
        } else if(res.code === myConst.code.logout){
            if(!isStop401){
                isStop401 = true
                router.push({path: "/"});
                store.commit("logoutClear"); //缓存数据清除
                store.commit("integSysMenu/clearMenu") //清除综合系统菜单相关数据
                store.commit('statMenu/clearStatMent') //清除电站菜单相关数据
                store.commit('enerStorSysMenu/clearEneryMenu') //清除储能系统菜单相关数据
                store.commit('photovoltaicSysMenu/clearPhotovoMenu') //清除光伏系统菜单相关数据
                element.Message.info(res.msg);
                location.reload();
                setTimeout(()=>{
                    isStop401 = false
                },2000)
            }
        } else {
            element.Message.info(res.msg);
        }
        return response;
    },
    error => {
        // 在这里捕获异常并进行处理
        if (error.response) {
            // 服务器响应了一个非 2xx 的状态码
            if (error.response.status === myConst.code.logout) {
                // 处理401错误
                console.log("Unauthorized: ", error.response);
            } else if (error.response.status === myConst.code.forbidden) {
                // 处理403错误
                console.log("Forbidden: ", error.response);
            } else {
                // 其他错误
                console.log("Other Error: ", error.response);
            }
        } else {
            // 没有收到任何响应
            console.log("No Response: ", error);
        }
        element.Message.info(error.response.data.msg);
        // 返回一个 Promise 对象，使得之后的处理器能够继续处理这个错误
        return Promise.reject(error);
    }
);

export default request;
